import colors from "constants/colors";
import { centerFlexCss } from "constants/css";
import React from "react";
import styled, { css } from "styled-components/macro";
import { joinClassnames } from "utils/map-modifier";
import "./index.scss";

type SizeProps = "small" | "medium" | "large";

type TypeProps = "no-data" | "danger" | "success";
interface UIPlaceholderProps {
  className?: string;
  type?: TypeProps;
  size?: SizeProps;
  fullParent?: boolean;
  noBackground?: boolean;
}

const UIPlaceholder: React.FC<UIPlaceholderProps> = ({
  className,
  children,
  size = "small",
  fullParent,
  noBackground,
  type = "no-data",
}) => {
  return (
    <StyledContainer
      className={joinClassnames(className)}
      size={size}
      type={type}
      fullParent={fullParent}
      noBackground={noBackground}
    >
      {children || "Không có dữ liệu"}
    </StyledContainer>
  );
};

type StyledContainerProps = {
  type: TypeProps;
  size: SizeProps;
  fullParent?: boolean;
  noBackground?: boolean;
};
const StyledContainer = styled.div<StyledContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  
  ${({ noBackground }) =>
    noBackground
      ? css``
      : css`
          background-color: #ebebeb;
        `}
  
  ${({ type }) => {
    switch (type) {
      case "no-data":
        return css`
          color: ${colors.pastelGray};
        `;
      case "danger":
        return css`
          color: ${colors.scarlet};
        `;
      case "success":
        return css`
          color: ${colors.shamrockGreen};
        `;
    }
  }}
  
  ${({ fullParent }) =>
    fullParent &&
    css`
      width: 100%;
      ${centerFlexCss};
    `}

  ${({ size }) => {
    switch (size) {
      case "small":
        return css`
          font-size: 10px;
          padding: 1em;
        `;
      case "medium":
        return css`
          font-size: 12px;
          padding: 2em;
        `;
      case "large":
        return css`
          font-size: 14px;
          padding: 3em;
        `;
    }
  }}
`;

export default UIPlaceholder;
